/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Erziehung12Inputs */

const en__field_enum_mzs_erziehung12 = /** @type {(inputs: _Field_Enum_Mzs_Erziehung12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pedagogy`)
};

const de__field_enum_mzs_erziehung12 = /** @type {(inputs: _Field_Enum_Mzs_Erziehung12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erziehungswissenschaften`)
};

/**
* | output |
* | --- |
* | "pedagogy" |
*
* @param {_Field_Enum_Mzs_Erziehung12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_erziehung12 = /** @type {((inputs?: _Field_Enum_Mzs_Erziehung12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Erziehung12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_erziehung12(inputs)
	return de__field_enum_mzs_erziehung12(inputs)
});
export { _field_enum_mzs_erziehung12 as "_field_enum_MZS_ERZIEHUNG" }